import React from 'react';
import { Button } from './ui/button';

const HeroSection = () => {
  return (
    <section className="pb-0 overflow-hidden relative min-h-screen">
      {/* Container with rounded bottom and gradient */}
      <div 
        className="relative"
        style={{
          background: 'linear-gradient(to bottom, #ffffff 0%, #ffffff 70%, #f3e8ff 95%, #ede4ff 100%)',
          borderBottomLeftRadius: '3rem',
          borderBottomRightRadius: '3rem',
          paddingBottom: '3rem'
        }}
      >
        <div className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 relative">
          {/* Left Professional Image - Bottom left corner, moved very high */}
          <div className="hidden lg:block absolute left-[-50px] bottom-60 animate-fade-in z-10">
            <img
              src="https://customer-assets.emergentagent.com/job_614ed27a-ecfd-41c1-b18b-261fcf3d21d5/artifacts/ria2axzu_1.png"
              alt=".decimal professional"
              className="w-auto h-[450px] xl:h-[500px] object-contain"
              style={{ 
                mixBlendMode: 'multiply',
                filter: 'brightness(1.1) contrast(1.05)'
              }}
            />
          </div>

          {/* Right Professional Image - Bottom right corner, moved very high */}
          <div className="hidden lg:block absolute right-[-50px] bottom-60 animate-fade-in z-10">
            <img
              src="https://customer-assets.emergentagent.com/job_614ed27a-ecfd-41c1-b18b-261fcf3d21d5/artifacts/q27llowd_2.png"
              alt=".decimal professional"
              className="w-auto h-[450px] xl:h-[500px] object-contain"
              style={{ 
                mixBlendMode: 'multiply',
                filter: 'brightness(1.1) contrast(1.05)'
              }}
            />
          </div>

          {/* Center Content */}
          <div className="text-center space-y-8 z-20 relative pt-12 md:pt-16 lg:pt-20 pb-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                India's 10 minute
                <br />
                <span className="text-gray-900">Beauty and Skincare App</span>
              </h1>
              <p className="text-lg md:text-xl text-gray-600">
                Now live in{' '}
                <span className="text-brand-500 font-semibold">
                  Indiranagar, Bengaluru!
                </span>
              </p>
            </div>

            {/* App Store Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://play.google.com/store/apps/details?id=com.decimalskincare&pcampaignid=web_share"
                className="inline-block transform hover:scale-105 transition-transform duration-200"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-16 md:h-20"
                />
              </a>
              <a
                href="https://apps.apple.com/in/app/decimal-beauty-shopping/id6748130980"
                className="inline-block transform hover:scale-105 transition-transform duration-200"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                  alt="Download on App Store"
                  className="h-16 md:h-20"
                />
              </a>
            </div>

            <div className="space-y-2">
              <p className="text-gray-600 text-lg">Made for you, curated by us</p>
              <p className="text-gray-500">— exactly what matters for your skin</p>
            </div>

            {/* Product Images */}
            <div className="flex justify-center items-center gap-4 mt-4">
              <img
                src="https://customer-assets.emergentagent.com/job_614ed27a-ecfd-41c1-b18b-261fcf3d21d5/artifacts/oi90ye98_7.png"
                alt="Skincare product"
                className="w-auto h-full max-h-[400px] object-cover rounded-2xl shadow-xl transform hover:-translate-y-2 transition-transform duration-300"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_614ed27a-ecfd-41c1-b18b-261fcf3d21d5/artifacts/hdac446f_3.png"
                alt="Skincare product"
                className="w-auto h-full max-h-[450px] object-cover rounded-2xl shadow-2xl z-10"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_614ed27a-ecfd-41c1-b18b-261fcf3d21d5/artifacts/alny3e8e_1.png"
                alt="Skincare product"
                className="w-auto h-full max-h-[400px] object-cover rounded-2xl shadow-xl transform hover:-translate-y-2 transition-transform duration-300"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;